<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">Agendador</a>
  </div>
  <!--nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select-->
</div>

<div class="header-container">
  <nb-actions size="small">


    <!--nb-action class="control-item" >
      <a class="link" (click)="abrirManual()">Manual de uso</a>
    </nb-action-->
    <nb-action class="control-item" *ngIf="esLocalOAdmin()">
      <a class="link" (click)="abrirComponenteVistaTurnos()">Vista de turnos en tiempo real</a>
    </nb-action>
    <nb-action class="control-item" >{{usuarioLogueado.usuario}}
      ({{usuarioLogueado.perfil}})
      {{(usuarioLogueado.proveedores && usuarioLogueado.proveedores.length>0)?'(TRANSPORTISTA)':''}}</nb-action>
    <nb-action class="control-item" (click)="logout()" icon="log-out-outline"></nb-action>
    <!--nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name"
               [picture]="user?.picture">
      </nb-user>
    </nb-action-->
  </nb-actions>
</div>
